import { useState } from "react";
import { GetEcshopAccountsResponseModel } from "@/features/accounts/ecshop/services/get-accounts-model";


export const useGetEcshopAccountStates = () => {
  const [institutionType, setInstitutionType] = useState("");
  const [ecshopAccountId, setEcshopAccountId] = useState("");
  const [ecshopAccounts, setEcshopAccounts] = useState<GetEcshopAccountsResponseModel[]>([]);

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
    errorCode: "",
  });

  return {
    institutionType,
    setInstitutionType,
    ecshopAccountId,
    setEcshopAccountId,
    ecshopAccounts,
    setEcshopAccounts,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
